<template>
    <v-menu bottom right>
    <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
            <v-icon>translate</v-icon>
        </v-btn>
    </template>
    <v-list>
        <v-list-item v-for="item in $config.locales" :key="item.short" @click="() => method(params, item.short)">
            <v-list-item-icon>
                <v-img  :src="`/static/flag-icons/${item.short}.png`" style="width: 25px;display:inline-block; margin:4px; margin-bottom:0px;" />
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
    </v-list>
</v-menu>
</template>

<script>
export default {
 props: ['method', 'params'],
}
</script>

<style>

</style>